export default __webpack_public_path__ + "static/media/1806.261b6225.png";